import React, { Component } from 'react';
import axios from "axios";
import moment from "moment";
import {connect} from "react-redux";
import css from './FieldJob2.module.scss';
import _ from 'lodash';
import SurveyForm from "../../components/FieldJobForms/SurveyForm";
import PartnerSurveyForm from "../../components/FieldJobForms/PartnerSurveyForm";
import InspectionForm from "../../components/FieldJobForms/InspectionForm";
import InstallForm from "../../components/FieldJobForms/InstallForm";
import MPUForm from "../../components/FieldJobForms/MPUForm";
import MiscElecForm from "../../components/FieldJobForms/MiscElecForm";
import BatteryForm from "../../components/FieldJobForms/BatteryForm";
import ServiceCallForm from "../../components/FieldJobForms/ServiceCallForm";

const FieldJob2 = class extends Component{
    // ---------- class fields: ----------
    source = axios.CancelToken.source();

    fieldJobId = this.props.match.params.field_job_id;

    state = {
        fieldJobData: {},
        sessionData: {},
        electricalWorkData: {},
        fieldTeamPicklist: [],
        activeFieldPersonnel: [],
        assignedCrew: {},
    };

    componentDidMount() {
        this.getFieldJob();
    }

    getFieldJob = () => {
        axios.get(
            `/sf/fieldjob/findOne/${this.fieldJobId}`,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data;
                this.setState({fieldJobData: data});

                let postRequestSchedulable = {
                    "limit": 1,
                    "skip": 0,
                    "fields": [
                        "Id",
                        "Name",
                        "CreatedDate",
                        "RecordTypeId",
                        "RecordType.Name",
                        "Assigned_Crew__c",
                        "Assigned_Crew__r.Account.SubType__c",
                        "Customer_Name__c",
                        "Survey_Type__c",
                        "Jobsite_Photos__c",
                        "Manufactured_home__c",
                        "Electrical_Type__c",
                        "Opportunity__c",
                        "Opportunity__r.Electrical_Work__c",
                        "Opportunity__r.Electrical_Work__r.Remaining_Electrical_Work__c",
                        "Opportunity__r.Electrical_Work__r.Backup_Switch__c",
                        "Case__c",
                        "Case__r.ToDoListValues__c"
                    ],
                    "where": {
                        "Id": data.Schedulable__c
                    }
                };

                axios.post(
                    '/sf/schedulable/findNo',
                    postRequestSchedulable,
                    {
                        cancelToken: this.source.token
                    })
                    .then((res) => {
                        const data = res.data;
                        this.setState({sessionData: data.records[0]});
                    })
                    .catch(err => console.log('(GET) Error tyring to fetch session: ', err));
                
            })
            .catch(err => console.log('(GET) Error tyring to fetch field job: ', err));

        this.getActiveField();
    };

    getActiveField = () => {
        let activeFieldPayload = {
            limit: 500,
            fields: {
                Id: 1,
                Name: 1,
                Payroll_ID__c: 1,
                Field_Team__c: 1
            },
            where: {
                Active__c: true,
                "$or": [
                    {
                        "Job_Department__c": "Installation"
                    },
                    {
                        "Job_Department__c": "Electrician"
                    }
                ]
            },
            orderBy: {
                Name: 1
            }
        };

        axios.post(
            '/sf/contact/findNo',
            activeFieldPayload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data;
                const field = [];

                _.each(data.records, function(v){
                    field.push({value: v.Name, id: v.Payroll_ID__c});
                });

                const filterField = _.uniqBy(field, function(o) { return o.value; });
                const orderedField = _.orderBy(filterField, ['value']);

                this.setState({
                    activeFieldPersonnel: orderedField,
                }); 
            })
            .catch(err => console.log('(GET) Error tyring to fetch active field personnel: ', err));
    };

    onSave = (value) => {
        if(value){
            this.getFieldJob();
        }
    }

    render() {
        if(Object.keys(this.state.sessionData).length ){
        return(
            <div>
                {/* ---------- Field List Attributes: ---------- */}
                <div className="row mt-3">
                    {/* ----- row 1: ----- */}
                    <div className="col-12 col-md-6 mb-2">
                        <h4>name</h4>
                        <h1>{ this.state.sessionData.Customer_Name__c ? this.state.sessionData.Customer_Name__c : '' }</h1>
                    </div>
                    <div className="col-12 col-md-6 mb-2">
                        <h4>type</h4>
                        <h1>{ this.state.fieldJobData.Type__c }</h1>
                    </div>

                    {/* ----- row 2: ----- */}
                    <div className="col-12 col-md-6 mb-2">
                        <h4>job date</h4>
                        <h1>{ moment(this.state.fieldJobData.Job_Date__c).format('MMM D, YYYY') }</h1>
                    </div>
                    <div className="col-12 col-md-6 mb-2">
                        <h4>scheduled time</h4>
                        <h1>{ this.state.fieldJobData.Scheduled_Time_Slot__c }</h1>
                    </div>

                    {/* ----- row 3: ----- */}
                    <div className="col-12 col-md-6 mb-2">
                        <h4>job start</h4>
                        <h1>{ moment(this.state.fieldJobData.Clocked_Start__c).format('MM/D/YYYY h:mmA') }</h1>
                    </div>
                    <div className="col-12 col-md-6 mb-2">
                        <h4>job end</h4>
                        <h1>{ this.state.fieldJobData.Clocked_End__c ? moment(this.state.fieldJobData.Clocked_End__c).format('MM/D/YYYY h:mmA') : '---' }</h1>
                    </div>

                    {/* ----- row 4: ----- */}
                    <div className="col-12">
                        <h4>Follow Up Needed?</h4>
                        <h1>{this.state.fieldJobData.Follow_up_needed_picklist__c}</h1>
                    </div>
                </div>
                {
                    this.state.fieldJobData.Type__c === 'Site Survey' && this.state.sessionData.Assigned_Crew__r.Account.SubType__c !== 'Full Ops Partner' ? 
                    <div>
                        <SurveyForm fieldJob={this.state.fieldJobData} session={this.state.sessionData} onSave={this.onSave} />
                    </div>
                    :
                    this.state.fieldJobData.Type__c === 'Site Survey' && this.state.sessionData.Assigned_Crew__r.Account.SubType__c === 'Full Ops Partner' ? 
                    <div>
                        <PartnerSurveyForm fieldJob={this.state.fieldJobData} session={this.state.sessionData} onSave={this.onSave} />
                    </div>
                    :
                    this.state.fieldJobData.Type__c === 'Install' ? 
                    <div>
                        <InstallForm fieldJob={this.state.fieldJobData} session={this.state.sessionData} fieldTeamPickList={this.state.fieldTeamPicklist} activeFieldPersonnel={this.state.activeFieldPersonnel} onSave={this.onSave} />
                    </div>
                    :
                    this.state.fieldJobData.Type__c === 'Electrical' && this.state.sessionData.Electrical_Type__c === 'MPU' ? 
                    <div>
                        <MPUForm fieldJob={this.state.fieldJobData} session={this.state.sessionData} fieldTeamPickList={this.state.fieldTeamPicklist} activeFieldPersonnel={this.state.activeFieldPersonnel} onSave={this.onSave} />
                    </div> 
                    :
                    this.state.fieldJobData.Type__c === 'Electrical' && this.state.sessionData.Electrical_Type__c === 'Miscellaneous Electrical' ? 
                    <div>
                        <MiscElecForm fieldJob={this.state.fieldJobData} session={this.state.sessionData} fieldTeamPickList={this.state.fieldTeamPicklist} activeFieldPersonnel={this.state.activeFieldPersonnel} onSave={this.onSave} />
                    </div> 
                    :
                    this.state.fieldJobData.Type__c === 'Electrical' && this.state.sessionData.Electrical_Type__c === 'Battery' ? 
                    <div>
                        <BatteryForm fieldJob={this.state.fieldJobData} session={this.state.sessionData} fieldTeamPickList={this.state.fieldTeamPicklist} activeFieldPersonnel={this.state.activeFieldPersonnel} onSave={this.onSave} />
                    </div> 
                    :
                    this.state.fieldJobData.Type__c === 'Inspection' ?
                    <div>
                        <InspectionForm fieldJob={this.state.fieldJobData} session={this.state.sessionData} onSave={this.onSave} />
                    </div>
                    :
                    this.state.fieldJobData.Type__c === 'Service Call' ?
                    <div>
                        <ServiceCallForm fieldJob={this.state.fieldJobData} session={this.state.sessionData} fieldTeamPickList={this.state.fieldTeamPicklist} activeFieldPersonnel={this.state.activeFieldPersonnel} onSave={this.onSave} />
                    </div>
                    :
                    ''
                }
            </div>
            
        );} else {
            return(
                <div className='text-white text-center'>
                    <div className={css.FieldJob2__Loader}></div>
                    <h2 className='pt-3'>Loading</h2>
                </div>
            );
        }
    }
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(FieldJob2);